import React, { memo } from 'react';

import { StyledWrapper } from './MainContainerLayoutStyles';

type MainContainerLayoutProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};

const MainContainerLayout = ({ children: content, className, id }: MainContainerLayoutProps) => {
  return (
    <StyledWrapper className={className} id={id}>
      {content}
    </StyledWrapper>
  );
};

export default memo(MainContainerLayout);
